export enum VoiceProvider {
	Cartesia = 'cartesia',
	Deepgram = 'deepgram',
	ElevenLabs = '11labs',
	OpenAI = 'openai',
	RIME = 'rime',
}
